import React from "react";
import {Autocomplete, Box, Button, Grid, TextField, Typography, useMediaQuery} from "@mui/material";
import {useTranslation} from "react-i18next";

export default function AutoComplete({
                                         data,
                                         addQuestion,
                                         deleteQuestionsAfterIndex,
                                         goToNextQuestion,
                                         isVisible,
                                         addToUpdateQuestions,
                                         deleteFromQuestionToUpdate,
                                     }) {
    // Constants
    const isMobile = useMediaQuery("(max-width:768px)");
    const {t} = useTranslation();
    const [value, setValue] = React.useState(data?.currentValue || "");
    const language = localStorage.getItem("i18nextLng");// Initialize with the default value

    // Optional filter function for the dropdown to filter data dynamically
    const filterOptions = (options, {inputValue}) => {
        const trimmedInput = inputValue.trim().toLowerCase(); // Trim and normalize input
        return options.filter((option) => {
            const translatedOption = t(option).toLowerCase(); // Translate options for filtering
            return translatedOption.includes(trimmedInput); // Check for matches
        });
    };

    // Function to handle the value change in autocomplete
    const handleValueChange = (event, newValue) => {
        deleteQuestionsAfterIndex(data);
        deleteFromQuestionToUpdate(data);
        setValue(newValue); // Set the new value
        if (data?.onChange) {
            data.onChange(newValue); // Trigger optional `onChange` callback
        }
    };

    // Handles the "Next" button click
    const handleNextClick = () => {
        // if (data.required && !value) {
        //     // Show an error if required and no value is selected
        //     alert(t("This field is required.")); // Replace with a better error handling mechanism if needed
        //     return;
        // }
        if (data && value && value !== data.currentValue) {
            addToUpdateQuestions(data, value);
        }
        // Add follow-up questions if the selected value has `question_object`
        if (value && data.choices.includes(value) && data.question_object) {
            addQuestion(data.question_object);
        } else {
            // Otherwise, move to the next question
            goToNextQuestion();
        }
    };

    function handleSkipClick() {
        if (data?.associated_step_id === "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b") {
            if (data?.question_object) {

                addQuestion(data?.question_object);
            } else {
                // Otherwise, move to the next question
                goToNextQuestion(null, true);
            }
        } else {
            goToNextQuestion(null, true);
        }
    }

    return (
        <Box
            style={{
                padding: "20px",
                width: "auto",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            }}
        >
            {/* Title Question */}
            <Typography variant="subtitle1" sx={{mb: 2}}>
                {language === "fr" ? data?.question_fr : data.question}
            </Typography>

            {/* AutoComplete Element */}
            <Grid container sx={{marginBottom: "20px"}}>
                <Autocomplete
                    value={value} // Current value of the autocomplete
                    options={data?.choices || []} // Choices for the dropdown
                    onChange={handleValueChange} // Set the state when user changes the value
                    getOptionLabel={(option) => t(option)} // Translate options
                    filterOptions={data?.filterable ? filterOptions : undefined} // Optional feature: custom filtering
                    fullWidth
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            // label={t(data?.label || "Select an option")} // Set label dynamically
                            placeholder={language === "fr" ? "Sélectionnez une option" : "Select an option"} // Placeholder
                        />
                    )}
                />
            </Grid>

            {/* Next Button */}

            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                {isVisible(data) && (
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{
                            height: "50px",
                            width: data?.associated_step_id !== "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b" ? "50%" : "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        onClick={handleNextClick}
                        disabled={data.required && !value} // Disable if required fields are empty
                    >
                        {data?.last_step_question_2 ? t("finish") : t("next")}
                    </Button>
                )}
                {isVisible(data) && (
                    <Button
                        style={{
                            height: "50px",
                            width: "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        color="secondary"
                        variant="contained"
                        onClick={handleSkipClick}
                    >
                        {t("skip")}
                    </Button>
                )}
            </div>

        </Box>
    );
}
